import React from "react";
import { css } from "@emotion/react";
import styles from "components/atoms/ListItem/styles";

const ListItem: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <li css={css(styles.container)}>{children}</li>;
};

export default ListItem;
